module.exports = __webpack_public_path__ + "img/swingVariabilityText10.69f87a78.png";